import { Switch } from "@material-ui/core";
import React, { useEffect, useState } from "react";

export default function StatusSwitch({
    enabled,
    disabled,
    onChange,
}: {
    enabled: boolean;
    disabled?: boolean;
    onChange: (enabled: boolean) => Promise<void>;
}) {
    const [checked, setChecked] = useState(enabled);
    const [pending, setPending] = useState(false);
    useEffect(() => {
        setChecked(enabled);
    }, [enabled]);

    const stop = (event: React.SyntheticEvent) => {
        event.stopPropagation();
    };

    return (
        <Switch
            color="primary"
            checked={checked}
            disabled={disabled || pending}
            onClick={stop}
            onChange={async (event) => {
                event.stopPropagation();
                if (pending) {
                    return;
                }
                const next = event.target.checked;
                setPending(true);
                setChecked(next);
                try {
                    await onChange(next);
                } catch {
                    setChecked(!next);
                } finally {
                    setPending(false);
                }
            }}
        />
    );
}
